import { NotificationTypeRecord } from '~/modules/notifications/types';
import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const notificationTypesQueryAtom = createQueryAtomFactory(
  'notifications.types',
  () => ({
    notificationTypes: {
      __args: {
        pagination: { offset: 0, limit: 100 },
        sorting: ['CategoryAsc' as const, 'KeyAsc' as const],
      },
      entries: {
        id: true,
        key: true,
        category: true,
        titleTemplate: true,
        bodyTemplate: true,
        defaultChannels: true,
        isCritical: true,
        icon: true,
      },
    },
  }),
  {
    select: (data) =>
      data?.notificationTypes?.entries?.map(
        (t): NotificationTypeRecord => ({
          id: t.id,
          key: t.key,
          category: t.category,
          titleTemplate: t.titleTemplate,
          bodyTemplate: t.bodyTemplate,
          defaultChannels: (t.defaultChannels as string[]) ?? [],
          isCritical: t.isCritical,
          icon: t.icon ?? undefined,
        }),
      ) ?? [],
    staleTime: 5 * 60_000,
  },
);
